import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "text-h4 text-center" }

import { computed } from 'vue'
import { useFormatDate } from '../composables/formatDate'
import { useUserStore } from '../store/useUserStore'
import { storeToRefs } from 'pinia'

export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineHeaderDate',
  props: {
    date: { default: undefined }
  },
  setup(__props: any) {

const props = __props
const store = storeToRefs(useUserStore())
const day = computed(() => useFormatDate(props.date, { language_choice: store.language }).day())
const weekday = computed(() =>
  useFormatDate(props.date, { language_choice: store.language }).weekday()
)
const month = computed(() => useFormatDate(props.date, { language_choice: store.language }).month())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(weekday.value) + ", " + _toDisplayString(month.value) + " " + _toDisplayString(day.value), 1)
  ]))
}
}

})